import * as React from 'react';

export const LongText: QuestionCardBodyComponent = () => {
  return (
    <div className='h-32 max-w-md rounded-md border border-gray-200 px-2 py-2 text-gray-400'>Long answer text</div>
  );
};
